export default __webpack_public_path__ + "static/media/mark.03a069a1.svg";